import React from 'react';
import { PRODUCT_NAME } from './salesData';

/** Pie de página con marca, contacto y avisos legales. */
export function Footer() {
  return <footer id="site-footer" className="w-full bg-carbon pb-28 pt-14 sm:pb-14" data-id="element-97" data-mp="3ggk7gsifd7yh">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-98" data-mp="32p5mig4yiwos">
        <div className="flex flex-col gap-8 border-b border-line pb-9 sm:flex-row sm:items-start sm:justify-between" data-id="element-99" data-mp="36p6df098t0cq">
          <div data-id="element-100" data-mp="3uesbfkdvp9j5">
            <p className="font-display text-lg leading-none text-bone" data-id="element-101" data-mp="3ug3bpa847z5i">
              KETO <span className="text-gold" data-id="element-102" data-mp="39904ifsbca6">4P</span>
            </p>
            <p className="mt-2 max-w-xs text-[0.85rem] leading-relaxed text-ash" data-id="element-103" data-mp="36d1erw44jko">
              {PRODUCT_NAME}. Producto digital: 6 tomos y 5 bonos en PDF.
            </p>
          </div>

          <ul className="space-y-2 text-[0.85rem] text-ash" data-id="element-104" data-mp="3qfjiuiukrhp6">
            <li data-id="element-105" data-mp="29y5fdwbbxcsw">
              <a href="#comprar" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-106" data-mp="29xm0kogz74j3">
                Comprar
              </a>
            </li>
            <li data-id="element-107" data-mp="3l9sk795mt0ql">
              <a href="#recetas" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-108" data-mp="3lbdd6ucasbmc">
                Las 4P
              </a>
            </li>
            <li data-id="element-109" data-mp="3v8hr66vzp0s2">
              <a href="#bonos" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-110" data-mp="3v919vptgrt75">
                Los 5 bonos
              </a>
            </li>
            <li data-id="element-111" data-mp="828lk264fx7k">
              <a href="#faq" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-112" data-mp="81pg3kxnr1af">
                Preguntas frecuentes
              </a>
            </li>
          </ul>
        </div>

        <p className="mt-7 text-[0.75rem] leading-relaxed text-ash/70" data-id="element-113" data-mp="hriflnkizpyb">
          El contenido de KETO 4P es material culinario e informativo. No constituye asesoramiento
          médico ni nutricional personalizado. Ante cualquier duda sobre tu alimentación, consultá
          con un profesional de la salud.
        </p>
        <p className="mt-4 text-[0.75rem] text-ash/70" data-id="element-114" data-mp="mtrawqkvf43l">
          © {new Date().getFullYear()} KETO 4P. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}